module.exports = __webpack_public_path__ + "299e889130948ffaedf19ab99f0c51cd.png";